<!-- src/components/Loader.vue -->
<template>
  <div class="spinner-wrapper">
    <div class="spinner" />
  </div>
</template>

<script>
export default {
  name: "LoaderView",
  props: {
    message: {
      type: String,
      default: "Indlæser..."
    }
  }
};
</script>

<style scoped>
.spinner-wrapper {
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  padding: 0;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #ccc;
  border-top-color: #2961D0;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>